import req from "@/utils/request";
export const evaluationPage = (params) => req.post("/evaluation/api/index/evaluation/page", params);
export const evaluationReport = (params) => req.get("/evaluation/api/index/evaluation/report", params);
export const createAccount = (params) => req.post("/evaluation/api/index/customer/register", params);
export const publishedPage = (params) => req.post("/evaluation/api/index/notify/page", params);
export const notifyIdDetail = (notifyId) => req.get(`/evaluation/api/index/notify/detail/${notifyId}`);


